import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';


export default function initStatsBlocks() {
  const blocks = document.querySelectorAll('.stats-block');
  if (!blocks.length) return;

  const mq = window.matchMedia('(max-width: 991px)');

  blocks.forEach((block) => {
    let statsSwiper = null;

    // Use a WeakMap or a property on the element to track initialization
    if (block.dataset.initialized) return;
    block.dataset.initialized = 'true';

    const container = block.querySelector('.stats');
    const paginationEl = block.querySelector('.stats__pagination');
    if (!container || !paginationEl) return;

    function enableSwiper() {
      if (statsSwiper) return;

      container.classList.add('swiper');

      let wrapper = container.querySelector('.swiper-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';
        [...container.querySelectorAll('.stats__item')].forEach((item) => {
          item.classList.add('swiper-slide');
          wrapper.appendChild(item);
        });
        container.appendChild(wrapper);
      }

      statsSwiper = new Swiper(container, {
        modules: [Pagination],
        slidesPerView: 'auto',
        spaceBetween: 16,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    }

    function disableSwiper() {
      if (!statsSwiper) return;

      statsSwiper.destroy(true, true);
      statsSwiper = null;

      const wrapper = container.querySelector('.swiper-wrapper');
      if (wrapper) {
        [...wrapper.children].forEach((slide) => {
          slide.classList.remove('swiper-slide');
          container.appendChild(slide);
        });
        wrapper.remove();
      }
      container.classList.remove('swiper');

      if (paginationEl) paginationEl.innerHTML = '';
    }

    function apply() {
      if (mq.matches) enableSwiper();
      else disableSwiper();
    }

    apply();
    mq.addEventListener('change', apply);
  });
}